var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 470,
    width: 28,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    transform: "translate(-162 -470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9959 2.91667C7.87815 2.91667 2.91871 7.87611 2.91871 13.9939 2.91871 20.1116 7.87815 25.0711 13.9959 25.0711 20.1137 25.0711 25.0731 20.1116 25.0731 13.9939 25.0731 13.9935 25.0731 13.9931 25.0731 13.9927 25.0752 7.87768 20.1197 2.91877 14.0047 2.91667 14.0017 2.91666 13.9988 2.91666 13.9959 2.91667ZM19.4265 14.98 14.982 14.98 14.982 19.4233 13.0098 19.4233 13.0098 14.9788 8.56538 14.9788 8.56538 13.0066 13.0098 13.0066 13.0098 8.56217 14.982 8.56217 14.982 13.0066 19.4265 13.0066Z",
    fill: "current",
    transform: "matrix(1 0 0 1.03571 162 470)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPlusIcon);
export default __webpack_public_path__ + "static/media/nav-plusIcon.531d663148d03ad4defe661e408daf77.svg";
export { ForwardRef as ReactComponent };